import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  NgForm,
} from "@angular/forms";
import { Location } from "@angular/common";
import { QuestionsService } from "../../services/questions.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { ErrorService } from "../../services/error.service";
import { FlashService } from "../../flash/flash.service";
import { Router } from "@angular/router";

@Component({
  selector: 'app-sorting-questions',
  templateUrl: './sorting-questions.component.html',
  styleUrls: ['./sorting-questions.component.css']
})
export class SortingQuestionsComponent implements OnInit {

  constructor(
    private location: Location,
    private questionservice: QuestionsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private errorService: ErrorService,
    private flashService: FlashService,
    private router: Router
  ) {}

  answers:any[] = [];
  tem:any;

  questionForm = new FormGroup({
    category: new FormControl("", Validators.required),
  });

  ngOnInit() {
  }

  onSubmit(){
    this.answers = [{},{}]
  }

}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/questions/sorting-questions/sorting-questions.component.ts